module.exports = __webpack_public_path__ + "img/1536838408.7f9c489e.jpg";